<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {
    
  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      this.$emit('setpage', 2);
      this.loading = false;
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="title text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/The listing process.png')" class="" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Getting started</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Listing your property for sale can be a complex process. We are continuously working to simplify it for you. The navigation bar to the left will show your progress along the way. If at any point you need help do not hesitate to reach out to us.</p>
        <p class="text-muted" data-aos="fade-zoom-in">Click Next to continue.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
